<section class="ui_collapsemutiselect2" ref="collapsemutiselect2">
  <div class="collapsemutiselect" :class="{'height132' : division,'heightAuto' : heightAuto,'border':dataArr.length}">
    <!-- <div class="collapsemutiselect_singleAdd" @click="openModal()" v-if="!dataArr.length">
      <iCon iconClass="icon-add" class="singleAdd_icon"></iCon>
      <div>{{$t('__c3r_c9n.__selectDevicesOrGroup')}}</div>
    </div> -->


    <!-- v-if="dataArr.length" -->
    <div class="collapsemutiselect_multiAdd" >
        
      <div class="collapsemutiselect_list">
        <Button type="border" wd="mmd" custom="icon"   @click="openModal()" 
          :text="scaleType == 'Devices' ?  $t('__d7d_n17r.__addDevice') :  $t('__c3r_c9n.__addGroups') " class="addButton" colors="main" theme="2">
          <template #icon>
            <iCon iconClass="icon-add" class="singleAdd_icon"></iCon>
          </template>
        </Button>

        <!-- <span  class="list_name addButton"
        @click="openModal()">
        <iCon iconClass="icon-add" class="singleAdd_icon"></iCon>
          {{ scaleType == 'Devices' ?  "Add Devices" : "Add Groups"  }}
        </span> -->


        <span v-for="(item, index) in data" :class="['each'+index ]" class="list_name"
          @click.stop="clickData($event,index,item)">
          {{item.name}}
        </span>
        <span v-for="(item, index) in fulfillArr" class="list_name dashEmpty"></span>
      </div>
    </div>
    <div class="collapsemutiselect_dropdown">
      <iCon iconClass="dropdown" :class="{'rotate_180': heightAuto}" @click="openBox" v-if="division"
        class="singleAdd_icon"></iCon>
    </div>
  </div>
  <div class="detailInfo" v-click-outside="handleFocusOut"
    :class="[(showDetail || showDetail == 0) && isMOdalEmpty  ? 'show':'noshow']" :style="itemClass">
    <div v-for="(item, index) in data">
      <div v-for="(each, name , i) in item" v-if="index == showDetail">
        <span v-if="name != 'name' && name !='val' && name != 'Model Name'">{{$t(name)}} : {{each}}</span>
      </div>
    </div>

  </div>
</section>